<div
  class="pie-wrapper progress-{{ progress }}  progress--{{ color }} progress--{{ size }}"
>
  <ng-content></ng-content>
  <div class="pie">
    <div class="left-side half-circle"></div>
    <div class="right-side half-circle"></div>
  </div>
  <div class="progress__base-circle"></div>
</div>
<div class="pie-background  progress--{{ size }}"></div>
